/**
 * SG AGM AFS — 엔티티 Profile 기반 폼 자동 채움.
 */
import { dateToHtmlInput } from '../../../change-financial-year-end/composables/dateToHtmlInput';
import {
  deriveAnnualReturnYearFromFye,
  type AgmAfsFormModel,
} from './useFormPayload';
import { formatRegisteredOfficeAddressFromProfile } from '../../agm-ufs/composables/agmUfsEntityAutofill';

export { formatRegisteredOfficeAddressFromProfile };

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

function unwrapEntityProfile(profileRaw: Record<string, unknown>): Record<string, unknown> {
  let p = profileRaw;
  for (let i = 0; i < 2; i += 1) {
    const inner = p?.data;
    if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
      const hasProfileShape =
        (inner as Record<string, unknown>).accountingDates != null
        || (inner as Record<string, unknown>).registeredAddress != null;
      if (hasProfileShape) {
        p = inner as Record<string, unknown>;
        continue;
      }
    }
    break;
  }
  return p;
}

export function applyEntityProfileToAgmAfsForm(
  model: AgmAfsFormModel,
  profileRaw: Record<string, unknown>,
  ent?: Record<string, unknown> | null,
): void {
  const profile = unwrapEntityProfile(profileRaw);
  const accounting = (profile.accountingDates as Record<string, unknown>) || {};

  const fye = dateToHtmlInput(
    accounting.financialYearEnd ?? accounting.FINANCIAL_YEAR_END ?? ent?.financialYearEnd,
  );
  const agmDue = dateToHtmlInput(
    accounting.nextAGMDueDate ?? profile.agmDuedate ?? profile.AGM_DUEDATE,
  );
  if (fye && !trim(model.financialYearEndDate)) {
    model.financialYearEndDate = fye;
  }
  if (!trim(model.annualReturnYear) && fye) {
    model.annualReturnYear = deriveAnnualReturnYearFromFye(fye);
  }
  if (agmDue && !trim(model.agmDate)) {
    model.agmDate = agmDue;
  }

  const addr = formatRegisteredOfficeAddressFromProfile(profile);
  if (addr && !trim(model.registeredOfficeAddress)) {
    model.registeredOfficeAddress = addr;
  }
}
